<template>
    <section class="farmerContainer">
        <div class="container-fluid farms">
            <div class="row margin_top_lg">
                <div class="col-lg-3 offset-lg-1">
                    <side-bar />
                </div>
                <div class="col-lg-7">
                    <div class="form-container">
                        <div class="">
                            
                            <h3 class="color__black font-bold margin_bottom_lg">Danger Zone!</h3>
                            
                            <div class="content_inner">
                                <p>
                                    First of all, are you sure? If its something we’ve done, 
                                    please <a href="#" class="font-bold">let us know.</a>
                                    We are always trying to improve and it makes us sad to see you go.
                                </p>
                                <p>
                                    Click the button below to delete all your records; 
                                    this includes your farmer records, transactions, sales and orders, messages.
                                </p>
                                <p class="font-bold">
                                    Are you sure you want to continue?
                                </p>
                            </div>
                            <div class="margin_top_lg">
                                <submit-button class="btn btn-secondary btn-sm">Ok, Delete my Account</submit-button>
                            </div>
                        </div>
                    </div>
                </div>
                
                
            </div>

            <div class="d-flex justify-content-end margin_top_lg">
                <button class="btn btn-support btn-sm py-2 font-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" class="mr-2" style="height: 16px; margin-bottom: -2px;"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11 5C8.23858 5 6 7.23858 6 10V11V18H3C1.89543 18 1 17.1046 1 16V12C1 10.8954 1.89543 10 3 10L4 10C4 6.13401 7.13401 3 11 3H13C16.866 3 20 6.13401 20 10H21C22.1046 10 23 10.8954 23 12V16C23 17.1046 22.1046 18 21 18H19.874C19.4299 19.7252 17.8638 21 16 21H14.7324C14.3866 21.5978 13.7403 22 13 22C11.8954 22 11 21.1046 11 20C11 18.8954 11.8954 18 13 18C13.7403 18 14.3866 18.4022 14.7324 19H16C17.1046 19 18 18.1046 18 17V11V10C18 7.23858 15.7614 5 13 5H11ZM4 12H3L3 16H4V12ZM11 12.25C11 12.9404 10.4404 13.5 9.75 13.5C9.05964 13.5 8.5 12.9404 8.5 12.25C8.5 11.5596 9.05964 11 9.75 11C10.4404 11 11 11.5596 11 12.25ZM14.25 13.5C14.9404 13.5 15.5 12.9404 15.5 12.25C15.5 11.5596 14.9404 11 14.25 11C13.5596 11 13 11.5596 13 12.25C13 12.9404 13.5596 13.5 14.25 13.5ZM20 12H21V16H20V12Z"
                            fill="#F2950A" />
                    </svg>
            
                    Support</button>
            </div>
        </div>
        
    </section>
</template>

<script>
import SideBar from '@/components/off-taker/SideBar'
export default {
    data() {
        return {
          deleting: false
        }
    },
    methods: {
      deleteAccount() {
        
      }
    },
    components: {
      SideBar
    }
}
</script>

<style>

</style>